import {Target} from '@phosphor-icons/react';
import {func, number, object} from 'prop-types';

export default function TargetSelectRow({index, style, data, onChange}) {
  const option = data.options[index];

  return (
    <div
      onClick={() => onChange(option)}
      style={style}
      className={`flex cursor-pointer items-center border-b border-base-300/30 px-4 dark:border-base-200 ${
        data.value === option ? 'bg-base-200' : ''
      }`}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex grow justify-start font-mono text-sm font-medium">{option}</div>
        <div className="flex w-8 justify-end">
          {data.target > 0 && data.options[index]?.toString() === data.target?.toString() ? (
            <Target size={16} aria-hidden="true" />
          ) : null}
        </div>
      </div>
    </div>
  );
}

TargetSelectRow.propTypes = {
  index: number.isRequired,
  style: object.isRequired,
  data: object.isRequired,
  onChange: func.isRequired,
};
